export function higherAduSearchOptions() {
  return [{
    value: 'attr',
    label: '受众属性',
    children: []
  },
  {
    value: 'event',
    label: '受众事件',
    children: []
  },
  {
    value: 'group',
    label: '受众群组',
    children: []
  },
  {
    value: 'aud_portary',
    label: '受众画像',
    children: [{
      label: '标签',
      value: 'tag@select',
      identity: 'tag'
    }]
  },
  {
    value: 'customer_kpi',
    label: '受众关键指标',
    children: [{
      label: '活跃度',
      value: 'activity@number',
      identity: 'activity'
    },
    {
      label: '7天活跃度',
      value: 'seven_activity@number',
      identity: 'seven_activity'
    },
    {
      label: '30天活跃度',
      value: 'thirty_activity@number',
      identity: 'thirty_activity'
    },
    {
      label: '价值评分',
      value: 'value_scoring@number',
      identity: 'value_scoring'
    },
    {
      label: '资料评分',
      value: 'score@number',
      identity: 'score'
    }
    ]
  },
  {
    value: 'follow_public',
    label: '关注公众号',
    children: [{
      label: '当前关注',
      value: 'follow_now@select',
      identity: 'means_integrate'
    },
    {
      label: '从未关注',
      value: 'follow_never@select',
      identity: 'follow_never'
    },
    {
      label: '取消关注',
      value: 'follow_cancel@select',
      identity: 'follow_cancel'
    }
    ]
  },
  {
    value: 'wechat_open_id',
    label: '受众身份',
    children: [{
      label: '微信openId',
      value: 'openId@input',
      identity: 'openId'
    }, ]
  }
    // ,
    // {
    //   value: 'aud_portary',
    //   label: '受众画像',
    //   children: [
    //     {
    //       label: '标签',
    //       value: 'tag@select',
    //       identity: 'tag'
    //     }
    //   ]
    // }
  ]
}

export const optionsValueArr = ['aud_portary', 'customer_kpi', 'wechat_open_id']

export function higherAduEventTimesList() {
  return [ // 客户事件--发生次数下拉
    {
      value: 'at_least_once',
      label: '至少一次'
    },
    // {
    //   value: 'no_once',
    //   label: '一次没有'
    // },
    {
      value: 'equal',
      label: '等于'
    },
    {
      value: 'lt',
      label: '小于'
    },
    // {
    //   value: 'lte',
    //   label: '小于等于'
    // },
    {
      value: 'gt',
      label: '大于'
    },
    // {
    //   value: 'gte',
    //   label: '大于等于'
    // },
    {
      value: 'gtele',
      label: '区间'
    }
  ]
}

export function higherAduAboutModels() {
  return [{
    label: '不限',
    name: '不限'
  },
  {
    label: '会员中心',
    name: '会员中心'
  },
  {
    label: '线下活动',
    name: '线下活动'
  }
  ]

}
export const higherAduPublicReplyTypes = [{
  title: '不限',
  id: '不限'
},
{
  title: '文本',
  id: '文本'
},
{
  title: '图片',
  id: '图片'
},
{
  title: '微页面',
  id: '微页面'
},
{
  title: '外部页面',
  id: '外部页面'
},
{
  title: '大转盘',
  id: '大转盘'
},
{
  title: '关联模块',
  id: '关联模块'
},
{
  title: '模板消息',
  id: '模板消息'
}
]

export function higherAduEventAttrOptions() {
  return [{
    attributeContent: '',
    relationOptions: [],
    eventAttrValueOptions: [],
    attributeRelation: '',
    attr_identity: '',
    attrValTimeStart: '',
    attrValTimeEnd: '',
    attributeValue: ''
  }]
}

export const higherAduRelationOptions = [{
  value: '=',
  label: '等于'
}, {
  value: '!=',
  label: '不等于'
}, {
  value: 'contain',
  label: '包含'
}, {
  value: 'not contain',
  label: '不包含'
}, {
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
}
]

export function higherAduRelateOpsOne() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  },
  {
    value: 'contain',
    label: '包含'
  },
  {
    value: 'not_contain',
    label: '不包含'
  }
  ]
}
export function higherAduRelateReversalOne() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'contain',
    label: '包含'
  },
  {
    value: 'not_contain',
    label: '不包含'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  },
  ]
}
export function higherAduRelateOpsTwo() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'before',
    label: '早于'
  },
  {
    value: 'past',
    label: '晚于'
  },
  {
    value: 'gtele',
    label: '区间'
  }
  ]
}
export function higherAduRelateOpsThree() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  },
  {
    value: 'contain',
    label: '包含'
  }
  ]
}
export function higherAduRelateOpsFour() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'gt',
    label: '大于'
  },
  {
    value: 'gte',
    label: '大于等于'
  },
  {
    value: 'lt',
    label: '小于'
  },
  {
    value: 'lte',
    label: '小于等于'
  },
  {
    value: 'gtele',
    label: '区间'
  }
  ]
}
export function higherAduRelateOpsFive() {
  return [{
    value: 'equal',
    label: '等于'
  }, {
    value: 'not_equal',
    label: '不等于'
  }, {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  }
  ]
}

export function higherAduRelateOpsSix() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'gt',
    label: '大于'
  },
  {
    value: 'lt',
    label: '小于'
  },
  {
    value: 'gtele',
    label: '区间'
  }
  ]
}

export function higherAduRelateOpsSeven() {
  return [{
    value: 'contain',
    label: '包含'
  },
  {
    value: 'not_contain',
    label: '不包含'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  }
  ]
}

export function higherAduRelateOpsEight() {
  return [{
    value: 'equal',
    label: '等于'
  },
  {
    value: 'lt',
    label: '早于'
  },
  {
    value: 'gt',
    label: '晚于'
  },
  {
    value: 'gtele',
    label: '区间'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  }
  ]
}

export const multipleModelList = ['multipleSelect', 'model']

export const higherInitTermGroupObj = {
  inOperator: 'and',
  terms: [{
    attr: 'attr',
    attr_label: '',
    relationship: '',
    relationOptions: [],
    value: null,
    option: [],
    startValue: '',
    endValue: '',
    //            original_id: null,
    //            eventAttributeList: [],
    //            activitiesTwo: [],
    //            templatesTwo: [],
    //            wepageTwo: [],
    eventAttrOptions: [{
      attributeContent: '',
      relationOptions: [],
      sources: [],
      eventAttrValueOptions: [],
      attributeRelation: '',
      attr_type: '',
      attr_identity: '',
      attrValTimeStart: '',
      attrValTimeEnd: '',
      attributeValueStart: '',
      attributeValueEnd: '',
      attributeValue: ''
    }],
    //            optionOther: null,
    //            qrcodeOptions: null,
    //            templateOption: null,
    //            qrcode: null,
    //            offline_qrcode: null,
    //            template_id: null,
    //            leave_word: null,
    //            public_reply_type_all: {
    //              reply_type: '不限',
    //              reply_content: ''
    //            },
    eventLimitTime: false,
    eventLimitTimes: false,
    eventLimitAttr: false,
    //            eventTimeRelation: '',
    //            eventDateStart: '',
    //            eventDateEnd: '',
    //            happenedTimes: '',
    //            start_time: '',
    //            end_time: '',
    selectedOptions: ['attr', '']
  }]
}

export const initItemTermsObj = {
  attr: 'attr',
  attr_label: '',
  relationship: '',
  relationOptions: [],
  value: null,
  option: [],
  startValue: '',
  endValue: '',
  eventAttrOptions: [{
    attributeContent: '',
    relationOptions: [],
    sources: [],
    eventAttrValueOptions: [],
    attributeRelation: '',
    attr_type: '',
    attr_identity: '',
    attrValTimeStart: '',
    attrValTimeEnd: '',
    attributeValueStart: '',
    attributeValueEnd: '',
    attributeValue: ''
  }],
  eventLimitTime: false,
  eventLimitTimes: false,
  eventLimitAttr: false,
  selectedOptions: ['attr', '']
}

export const selDicAddList = ['select', 'dict', 'addressPicker']

export const datePickerArr = ['datePicker', 'dateTimePicker']